import * as React from "react";
import * as _ from "underscore";
import Select from "react-select";

import { PropertyRepairShape } from "@eave/shared/types/api";
import LabeledInput from "../../../LabeledInput";

interface RepairEntryProps {
  prefix: string;
  repairs: {
    map: Function;
    length: number;
    [index: number]: PropertyRepairShape;
  };
  onChange: Function;
}

class RepairEntry extends React.Component<RepairEntryProps, any> {
  constructor(props) {
    super(props);

    // assumption is that we'll have three fields for each prefix:
    // -- in_<prefix>
    // -- <prefix>_cost_to_cure
    // -- <prefix>_note

    if (props.prefix !== "appraisal" && props.prefix !== "inspection") {
      throw new Error("prefix must be either 'appraisal' or 'inspection'");
    }
  }

  onChangeSelect(repairType, e) {
    const { prefix, repairs, onChange } = this.props;

    const repairPresent = e ? e.value : null;

    const updated = _.map(repairs, (r: PropertyRepairShape) => {
      if (r.repair_type === repairType) {
        return {
          ...r,
          [`in_${prefix}`]: repairPresent,
          [`${prefix}_cost_to_cure`]: repairPresent ? r[`${prefix}_cost_to_cure`] : null,
          [`${prefix}_note`]: repairPresent ? r[`${prefix}_note`] : null,
        };
      }
      return r;
    });

    onChange(updated);
  }

  onChangeMoney(repairType, e) {
    const { prefix, repairs, onChange } = this.props;

    let parsedVal;
    if (!e.target.value || e.target.value === "0") {
      parsedVal = null;
    } else {
      parsedVal = e.target.value;
    }

    const updated = _.map(repairs, (r: PropertyRepairShape) => {
      if (r.repair_type === repairType) {
        return {
          ...r,
          [`${prefix}_cost_to_cure`]: parsedVal,
        };
      }
      return r;
    });

    onChange(updated);
  }

  onChangeText(repairType, e) {
    const { prefix, repairs, onChange } = this.props;

    const updated = _.map(repairs, (r: PropertyRepairShape) => {
      if (r.repair_type === repairType) {
        return {
          ...r,
          [`${prefix}_note`]: e.target.value || null,
        };
      }
      return r;
    });

    onChange(updated);
  }

  renderSection(eligible: boolean) {
    const { prefix, repairs } = this.props;

    const filteredRepairs = _.chain(repairs).where({ eligible }).sortBy("repair_type").value();

    return (
      <div className="property-condition__section">
        <div>
          <div className="property-condition__section-name">
            {eligible ? "Eligible" : "Ineligible"} repairs
          </div>
          <div className="property-condition__section-question">
            Are any of these indicated in the {prefix} on the left?
          </div>
        </div>
        <div>
          {filteredRepairs.map((r: any) => {
            let costToCure;
            if (r[`${prefix}_cost_to_cure`] !== null) {
              costToCure = `${r[`${prefix}_cost_to_cure`]}`; // string
            } else {
              costToCure = "";
            }

            return (
              <div key={r.repair_type} className="property-condition__field">
                <div className="property-condition__field-name">{r.description}</div>
                <Select
                  placeholder="—"
                  searchable={false}
                  value={r[`in_${prefix}`]}
                  options={[
                    { value: false, label: "No" },
                    { value: true, label: "Yes" },
                  ]}
                  onChange={this.onChangeSelect.bind(this, r.repair_type)}
                />
                {r[`in_${prefix}`] && (
                  <LabeledInput
                    inputType="money"
                    inputValue={costToCure}
                    clearable
                    onChange={this.onChangeMoney.bind(this, r.repair_type)}
                  />
                )}
                {r[`in_${prefix}`] && (
                  <textarea
                    placeholder="Repair notes"
                    value={r[`${prefix}_note`] || ""}
                    onChange={this.onChangeText.bind(this, r.repair_type)}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderSection(false)}
        {this.renderSection(true)}
      </div>
    );
  }
}

export default RepairEntry;
